import { Title } from '@cambridgeassessment/cambridge-ui';
import styled from 'styled-components';

export const StyledInputContainer = styled.div`
  width: 464px;
  margin-bottom: 24px;
`;

export const StyledTitle = styled(Title)`
  margin-bottom: 0px;
`;
